<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="py-0 px-3" cols="12" sm="6" md="3">
        <legend>Prestador</legend>
        <v-select
          v-model="formData.prestador_id"
          :items="prestadoresFilter"
          item-value="id"
          item-text="prest_nome"
          :menu-props="{ bottom: true, offsetY: true }"
          placeholder="Selecione"
          flat
          solo
          dense
          outlined
        ></v-select>
      </v-col>
      <v-col class="py-0 px-3" cols="12" sm="6" md="3">
        <legend>Operadora</legend>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          v-model="formData.operadora_ans_id"
          :items="operadorasFilter"
          placeholder="Selecione"
          outlined
          item-text="oper_nome"
          item-value="id"
        ></v-select>
      </v-col>
      <v-col class="py-0 px-3" cols="12" sm="6" md="3">
          <label>Período</label>
          <v-menu
            ref="dt"
            v-model="dt"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormatted"
                dense
                format="MM/YYYY"
                placeholder="MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="date = parseDateMonth(dateFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="date" type="month" no-title scrollable></v-date-picker>
          </v-menu>
      </v-col>
      <v-col class="pb pt-5 px-2" cols="6" sm="3" md="1">
        <v-btn width="100%" height="30px" small color="primary" depressed class="px-5" @click="updateFilter(formData)">Filtrar</v-btn>
      </v-col>
      <v-col class="pb-0 pt-5 px-3" cols="6" sm="3" md="2">
        <v-btn
          outlined
          width="100%"
          height="30px" 
          small
          color="primary"
          depressed
          class="px-5"
          @click="clearFilters()"
          >Limpar Filtro</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        prestador_id: null,
        operadora_ans_id: null,
        dt_faturamento: null,
      },
      prestadoresFilter: [],
      operadorasFilter: [],
      date: null,
      dateFormatted: null,
      dt: false
    }
  },
  watch: {
    dataReferencia: {
      deep: true,
      handler(val){
        if(val) {
          this.dateFormatted = this.formatDateMonth(val)
          this.formData.dt_faturamento = val
        }
      }
    },
    prestadores:{
      deep: true,
      handler(val){
        this.prestadoresFilter = Array.from(val)
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador_id = this.prestadoresFilter[0].id
          this.updateFilter(this.formData, null, 'DashFilter - watch - Faturamento')
        } else {
          this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        }
      }
    },
    operadoras:{
      deep: true,
      handler(val){
        this.operadorasFilter = Array.from(val)
        this.operadorasFilter.unshift({id: null, oper_nome: "Selecione"})
      }
    },
    date(val){
      this.dateFormatted = this.formatDateMonth(val)
      this.formData.dt_faturamento = val
    },
    // dateFormatted(val){
    //   val = val.split('/')
    //   val.splice(0,1)
    //   val = val.join('/')
    //   this.formData.dt_faturamento = this.parseDateMonth(val)
    // },
  },
  methods: {
    clearFilters(){
      this.dateFormatted = null
      this.date = null
      this.formData.dt_faturamento = null
      this.formData.operadora_ans_id = null
      if (this.prestadoresFilter.length>1) {
        this.formData.prestador_id = null
      }
      this.updateFilter(this.formData, null)
    },
    formatDateMonth(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}/${year}`;
    },
    parseDateMonth(date) {
      if (!date) return null;
      const [month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}`;
    }
  },
  props: {
    dataReferencia: String,
    operadoras: Array,
    prestadores: Array,
    updateFilter: Function,
  }
};
</script>
